import { render, staticRenderFns } from "./OpeningFormComponent.vue?vue&type=template&id=aadc26ca&xmlns=true&"
import script from "./OpeningFormComponent.vue?vue&type=script&lang=js&"
export * from "./OpeningFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aadc26ca')) {
      api.createRecord('aadc26ca', component.options)
    } else {
      api.reload('aadc26ca', component.options)
    }
    module.hot.accept("./OpeningFormComponent.vue?vue&type=template&id=aadc26ca&xmlns=true&", function () {
      api.rerender('aadc26ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-attraction/basic-data/forms/opening-form/OpeningFormComponent.vue"
export default component.exports